// extracted by css-extract-rspack-plugin
export default {"listFooter":"SqpwCCIYkzk0dE7X","popover":"WdJmZzPM6XsHIBYl"};